module.exports = __webpack_public_path__ + "img/newchris-35.3c57b608.jpg";